import s from "./CategoryFixedMobile.module.scss";
import alllCategories from '../../assets/all_cats.png';

const CategoryFixedMobile = ({categories, onCategoryClick}) => {
    return (
        <div className={s.categoryList}>
            <div
                key={"all"}
                className={s.item}
                style={{backgroundColor: "#556270"}}
                onClick={() => {

                    onCategoryClick("")
                }}
            >
                <div className={s.card}>
                    <img src={alllCategories} alt=""/>
                    <div className={s.overlayBelow}>

                        <div className={s.overlayBelowText}> すべてのツアー</div>
                    </div>
                </div>
            </div>

            {categories.slice(0, 7).map((item, i) => {
                const getColorByIndex = (i) => {
                    const colors = ["#FF6B6B", "#4ECDC4", "#556270", "#C7F464", "#FFB400", "#6C5CE7"];
                    return colors[i % colors.length];
                };

                return (

                    <div
                        key={i}
                        className={s.item}
                        style={{backgroundColor: getColorByIndex(i)}}
                        // style={{ flex: `0 0 ${100 / itemsPerView}%` }}
                        onClick={() => {

                            onCategoryClick(item.id)
                        }}
                    >
                        <div className={s.card}>
                            <img src={item.thumb} alt=""/>
                            <div className={s.overlayBelow}>

                                <div className={s.overlayBelowText}> {item.name}</div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )

};

export default CategoryFixedMobile;